module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-ja-6af82cdbe5a1f6f05b43d972b66a4050.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-ja.svg
// module id = FkCo
// module chunks = 3 9